<template>
     <div id="app">
          <router-view></router-view>
     </div>
</template>

<script>

export default {
     name: 'App',
     metaInfo() {
         return {
             title: "Concursul anual 2020 - Fotografi-Cameramani.ro",
             meta: [
                 {name: 'description', content:  'Concursul anual 2020 - Fotografi-Cameramani.ro'},
                 {property: 'og:title', content: "Concursul anual 2020 - Fotografi-Cameramani.ro"},
                 {property: 'og:site_name', content: 'Fotografi-Cameramani.ro'},
                 {property: 'og:type', content: 'website'},
                 {property: 'og:image', content: 'https://www.fotografi-cameramani.ro/layout/standard/images/ca2020/og_image.jpg'},
             ]
         }
     },
     components: {
     }
}
</script>

<style lang="scss">

@import './assets/scss/_variables.scss';
@import './assets/scss/_general.scss';
@import '../node_modules/bootstrap/scss/bootstrap.scss';

@import url('https://fonts.googleapis.com/css?family=Open+Sans');

html, body {
    font-family: 'Open Sans';

    @media (max-width: 768px) {

        font-size: 90%;

        h1 {
            font-size: 30px;
        }

        h3 {
            font-size: 20px;
        }
    }
}

</style>
